export default (props, vars) => props?.['status'] === 'REJECTED';
